export const BASENAME = ""; // don't add '/' at end off BASENAME
export const BASE_URL = "/";
export const BASE_TITLE = " | One Dream Architects";
export const API_SERVER = process.env.REACT_APP_API_SERVER;
export const API_SERVER_PLAIN = process.env.REACT_APP_API_SERVER_PLAIN;
